module.exports = __webpack_public_path__ + "img/stage_transit.cc11edbd.svg";